import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { baseUrl } from "../../utils";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import { getCurrentDate } from "../../utils";
import {
  createGuardianRequest,
  deleteGuardianInformation,
} from "../../store/reducer/accountReducer";
import Loader from "../loader";

const GuardianParentPage = ({ nextComponent, prevComponent }) => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behaviour: "smooth" });
  }, []);

  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [validEmail] = useState("");
  const [docSubmit, setDocumentSubmit] = useState(false);
  const [isYesChecked, setIsYesChecked] = useState(false);
  const [isNoChecked, setIsNoChecked] = useState(false);
  const [showAccountValid, setShowAccountValid] = useState(false);
  const [invalidAcctMsg, setInvalidAcctMsg] = useState("");

  const handleYesChecked = () => {
    setIsYesChecked(!isYesChecked);
    setIsNoChecked(false);
  };

  const handleNoChecked = () => {
    setIsNoChecked(!isNoChecked);
    setIsYesChecked(false);
    setInvalidAcctMsg("");
  };

  const dispatch = useDispatch();
  const nationalityCode = "566#Nigeria";
  const [data, setData] = useState({
    title: "",
    bvn: "",
    surName: "",
    firstName: "",
    middleName: "",
    mothersMaidenName: "",
    nationality: "",
    stateOfOrigin: "",
    gender: "",
    lga: "",
    idNumber: "",
    residentialAddress: "",
    residentialLGA: "",
    stateOfResidence: "",
    mobileNumber: "",
    emailAddress: "",
    dateIssue: "",
    bothSignatory: false,
    eitherSignatory: false,
    soleSignatory: false,
    introducerCode: "",
    relationship: "",
    residentPermitNumber: "",
    placeOfPermitIssue: "",
    permitExpiryDate: "",
    permitIssueDate: "",
    sunTrustAccount: "",
    sunTrustAccountNumber: "",
    accountName: "",
    haveSunTrustBankAccount: "",
    documents: [],
  });

  const [showSignatory, setShowSignatory] = useState(true);

  const { loading } = useSelector((state) => state.account);

  const guardianInformations = useSelector(
    (state) => state.account.createAccount.guardianInformations
  );

  const [guardianData, setGuardianData] = useState(guardianInformations);
  const [isLoading, setIsLoading] = useState(false);

  const handleNextClick = () => {
    nextComponent();
  };

  const handlePrevClick = () => {
    prevComponent();
  };

  /* START OF ADD DOCUMENTS HANDLE */

  const handleAddDocument = (e) => {
    e.preventDefault();
    if (!selectedFile) {
      setErrorMessage("Please upload a document");
      return;
    }
    if (!selectedOption) {
      setErrorMessage("Please select an option");
      return;
    }
    setDocumentSubmit(true);

    const { value } = document.getElementById("document-type");
    const fileInput = document.getElementById("document-file");
    const errorMessage = document.getElementById("error-message");
    if (fileInput.files.length > 0) {
      const file = fileInput.files[0];
      const fileType = file.type;
      const fileSize = file.size / 1024; // Convert to KB
      const allowedTypes = [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "application/pdf",
      ];
      const allowedSize = 500; // KB
      // setTheDetailsForTable((current) => [...current, data]);

      if (allowedTypes.includes(fileType) && fileSize <= allowedSize) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
          const base64String = reader.result;
          setData((prevData) => {
            const newDocument = {
              documentType: value,
              name: file.name,
              dateIssued: moment(new Date()).format("YYYY-MM-DD"),
              dateExpired: moment(new Date()).format("YYYY-MM-DD"),
              file: base64String,
            };

            if (prevData.documents && Array.isArray(prevData.documents)) {
              return {
                ...prevData,
                documents: [...prevData.documents, newDocument],
              };
            } else {
              return {
                ...prevData,
                documents: [newDocument],
              };
            }
          });
          document.getElementById("document-type").selectedIndex = 0; // reset the select element
          document.getElementById("document-file").value = "";
          errorMessage.textContent = "";
        };
      } else {
        if (!allowedTypes.includes(fileType)) {
          errorMessage.textContent =
            "Please upload a file of type jpg, jpeg, pdf or png";
        } else {
          errorMessage.textContent =
            "Please upload a file of size up to 500 KB.";
        }
      }
    }
    setSelectedFile(null);
    setSelectedOption("");
    setErrorMessage("");
  };

  /* START OF DOCUMENT VIEW HANDLES */
  const handleViewDocument = (base64String) => {
    const pdfWindow = window.open("");
    pdfWindow.document.write(
      `<iframe width='100%' height='100%' src='${base64String}'></iframe>`
    );
  };

  const handleDeleteDocument = (index) => {
    setData((prevData) => {
      const updatedDocuments = [...prevData.documents];
      updatedDocuments.splice(index - 1, 1); // Remove the document at the given index
      return {
        ...prevData,
        documents: updatedDocuments,
      };
    });
  };

  const deleteCheck = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteGuardianInformation(index));
        Swal.fire("Deleted!", "Entry deleted.", "success");
      }
    });
  };
  const deleteDoc = (index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Call handleDeleteDocument passing the index
        handleDeleteDocument(index);

        Swal.fire("Deleted!", "Your file has been deleted.", "success");
      }
    });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setData((prevData) => ({
        ...prevData,
        [name]: checked,
      }));
    } else if (name === "bvn") {
      const bvnRegex = /^[0-9]*$/; // Only allow numbers
      if (!bvnRegex.test(value)) {
        return;
      } else {
        setData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      }
    } else if (name === "idNumber") {
      const regex = /^[a-zA-Z0-9]*$/; // Only allow numbers
      if (!regex.test(value)) {
        return;
      } else {
        setData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      }
    } else {
      setData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  // START OF HANDLE SUBMIT
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!docSubmit) {
      setErrorMessage("Please upload a document");
      return;
    } else {
      setDocumentSubmit(false);
    }
    setIsLoading(true);
    setShowSignatory(false);
    if (data.haveSunTrustBankAccount === "") {
      let haveSunTrustBankAccount = "o";
      data.haveSunTrustBankAccount = haveSunTrustBankAccount;
      dispatch(createGuardianRequest(data));
    } else {
      dispatch(createGuardianRequest(data));
    }

    setData({
      title: "",
      bvn: "",
      surName: "",
      firstName: "",
      middleName: "",
      mothersMaidenName: "",
      nationality: "",
      stateOfOrigin: "",
      gender: "",
      lga: "",
      idNumber: "",
      residentialAddress: "",
      residentialLGA: "",
      stateOfResidence: "",
      mobileNumber: "",
      emailAddress: "",
      eitherSignatory: false,
      soleSignatory: false,
      bothSignatory: false,
      introducerCode: "",
      relationship: "",
      residentPermitNumber: "",
      placeOfPermitIssue: "",
      permitExpiryDate: "",
      permitIssueDate: "",
      sunTrustAccount: "",
      sunTrustAccountNumber: "",
      accountName: "",
      haveSunTrustBankAccount: "",
      documents: [],
    });
    setErrorMessage("");
  };

  // END OF HANDLE SUBMIT

  useEffect(() => {
    setGuardianData(guardianData);
    if (!loading && isLoading) {
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }
  }, [loading, isLoading, guardianData]);

  // VALIDATE ACCOUNT NUMBER START

  const validateAcctNum = async (event) => {
    const nuban = event.target.value;

    if (nuban.length === 10) {
      // Check if the account number has 10 digits
      setIsLoading(true);
      setInvalidAcctMsg("");

      try {
        const headers = { "Content-Type": "application/json" };
        const response = await axios.post(
          "https://digitalbanking.suntrustng.com/digitalsrv/webresources/customer",
          { nuban },
          { headers },
          { auth: { username: "gims", password: "gims" } }
        );

        // console.log(">>>>>>>response from nuban", response.data.customerData.accountname);
        if (response.data.responsecode === "96") {
          setInvalidAcctMsg("Incorrect account number");
          // return response.data;
        }
        if (response.data.responsecode === "00") {
          setData((prevData) => ({
            ...prevData,
            accountName: response.data.customerData.accountname,
          }));

          setShowAccountValid(true);

          // return response.data;
        }
        setIsLoading(false);
      } catch (error) {
        // console.log(error).error(error); // Log any errors that occur during the request
        setIsLoading(false);
        setInvalidAcctMsg("An error occured.Please try again");
      }
    } else {
      // Log if the account number does not have 10 digits
      setInvalidAcctMsg("Incorrect account number");
    }
  };

  useEffect(() => {
    validateAcctNum();
  }, []);
  //  END VALIDATE ACCOUNT NUMBER

  // START OF UPDATE BVN
  const handleBvnChange = async (event) => {
    const bvn = event.target.value;
    const authToken = sessionStorage.getItem("bvnAuthToken");
    if (bvn.length === 11) {
      setIsLoading(true);
      try {
        const response = await axios.post(
          `https://digitalbanking.suntrustng.com:8443/bvn_validation_new/api/BVNValidations/ValidateBVNMasked`,
          { bvn }
        );
        // console.log(response);

        setData((prevData) => ({
          ...prevData,
          bvn: response.data.bvnDetails.bvn,
          firstName: response.data.bvnDetails.firstName,
          surName: response.data.bvnDetails.lastName,
          mobileNumber: response.data.bvnDetails.phoneNumber1,
          emailAddress: response.data.bvnDetails.email,
          gender: response.data.bvnDetails.gender,
        }));

        // console.log("BVN Response", data);

        setIsLoading(false);
      } catch (error) {
        // console.log(error).log(error);
        setIsLoading(false);
      }
    }
  };

  // END OF UPDATE BVN

  // START OF STATE UPDATE
  const [states, setStates] = useState([]);
  useEffect(() => {
    axios
      .get(
        "https://ubanking.suntrustng.com/AccountOpeningV2/api/v1/AccountOpening/GetState"
      )
      .then((response) => {
        const sortedStates = response.data.sort((a, b) =>
          a.text.localeCompare(b.text)
        );
        setStates(sortedStates);
      })
      .catch((error) => {
        // console.log(error).log(error);
      });
  }, []);

  // END OF UPDATE STATE

  // START OF LGA UPDATE
  const [lgas, setLgas] = useState([]);
  useEffect(() => {
    axios
      .get(
        "https://ubanking.suntrustng.com/AccountOpeningV2/api/v1/AccountOpening/GetLocalGovt"
      )
      .then((response) => {
        const sortedLgas = response.data.sort((a, b) =>
          a.text.localeCompare(b.text)
        );
        setLgas(sortedLgas);
      })
      .catch((error) => {
        // console.log(error).log(error);
      });
  }, []);

  // END OF UPDATE LGA

  // START OF UPDATE DOCUMENT TYPE
  const [docs, setDocs] = useState([]);
  useEffect(() => {
    axios
      .get(
        "https://ubanking.suntrustng.com/AccountOpeningV2/api/v1/UploadType/GetDocumentType"
      )
      .then((response) => {
        setDocs(response.data);
      })
      .catch((error) => {
        // console.log(error).log(error);
      });
  }, []);

  // END OF UPDATE DOCUMENT TYPE

  return (
    <div className="page">
      <div className="flex-column">
        <div className="kiddies_hero m-b-30"></div>

        <div className="kiddies_hero-tablet m-b-30"></div>

        <div className="kiddies_hero-mobile m-b-30"></div>

        <div className="col-lg-12  m-b-50 ">
          <section className="step-wizard m-b-30">
            <ul className="step-wizard-list">
              <li className="step-wizard-item m-b-10">
                <span className="progress-count">1</span>
                <span className="progress-title">Introduction</span>
              </li>
              <li className="step-wizard-item m-b-10">
                <span className="progress-count">2</span>
                <span className="progress-title">Child Information</span>
              </li>
              <li className="step-wizard-item current-item">
                <span className="progress-count">3</span>
                <span className="progress-title">
                  Parent / Guardian Information
                </span>
              </li>

              <li className="step-wizard-item">
                <span className="progress-count">4</span>
                <span className="progress-title">Review Information</span>
              </li>
            </ul>
          </section>

          <section className="step-wizard-tablet m-b-30">
            <ul className="step-wizard-list">
              <li className="step-wizard-item m-b-10">
                <span className="progress-count">1</span>
                <span className="progress-title">Introduction</span>
              </li>
              <li className="step-wizard-item m-b-10">
                <span className="progress-count">2</span>
                <span className="progress-title">Child Information</span>
              </li>
              <li className="step-wizard-item current-item m-b-10">
                <span className="progress-count">3</span>
                <span className="progress-title">
                  Parent / Guardian Information
                </span>
              </li>
              <li className="step-wizard-item">
                <span className="progress-count">4</span>
                <span className="progress-title">Upload Documents</span>
              </li>
              <li className="step-wizard-item">
                <span className="progress-count">5</span>
                <span className="progress-title">Review Information</span>
              </li>
            </ul>
          </section>

          <div className="tab-content" id="myTabContent">
            <div
              className="fade show active"
              id="account_spec"
              role="tabpanel"
              aria-labelledby="account_spec-tab"
            >
              <form onSubmit={handleSubmit} onChange={handleChange}>
                {/* <!-- PERSONAL DETAILS --> */}
                <div className="section-info m-b-50">
                  <div className="section-title font-weight-500 font-24 m-b-10 border-bottom p-1 text-suntrust">
                    <i className="fa fa-user m-r-5"></i> Personal Information
                  </div>

                  {/* <!-- <div className="row"> --> */}
                  <div className="main-section d-flex">
                    <div className="col-lg-3 col-md-12 col-sm-12 m-r-30 section-sub-text">
                      <div className="font-weight-300 font-14 text-gray">
                        This is a section where the personal details of the
                        guardian is entered. Please, provide the correct
                        details.
                      </div>
                    </div>

                    <div className="section-forms p-10 col-lg-9 col-md-12 col-sm-12">
                      {/* <!-- <div className="col-lg-12"> --> */}
                      <div className="row">
                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            Bank Verification Number (BVN){" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="bvn"
                            value={data.bvn}
                            required
                            maxLength={11}
                            onChange={handleBvnChange}
                            style={{
                              paddingRight: "30px",
                              position: "relative",
                            }}
                          />
                          {isLoading && (
                            <div
                              style={{
                                position: "absolute",
                                top: "70%",
                                right: "25px",
                                transform: "translateY(-50%)",
                              }}
                            >
                              <Loader />
                            </div>
                          )}
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            Title <span className="text-danger">*</span>
                          </label>
                          <select
                            name="title"
                            id="mrormrs"
                            className="form-control"
                            required
                            value={data.title}
                            onChange={handleChange}
                          >
                            <option
                              value=""
                              defaultValue="selected"
                              disabled="disabled"
                            >
                              -Select Title-
                            </option>
                            <option value="1#Mr">Mr</option>
                            <option value="2#Mrs">Mrs</option>
                          </select>
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            Firstname <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="firstName"
                            disabled
                            value={data.firstName}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>Middlename</label>
                          <input
                            type="text"
                            className="form-control"
                            name="middleName"
                            value={data.middleName}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            Surname <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="surName"
                            disabled
                            value={data.surName}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            Mobile Number <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="mobileNumber"
                            disabled
                            value={
                              data.mobileNumber
                                ? data.mobileNumber
                                    .toString()
                                    .replace(/(\d{4})\d+(\d{2})/, "$1*****$2")
                                : ""
                            }
                            onChange={handleChange}
                          />
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            Email Address <span className="text-danger">*</span>
                          </label>
                          <input
                            type="emailAddress"
                            className="form-control"
                            name="emailAddress"
                            required
                            value={data.emailAddress}
                            onChange={handleChange}
                          />
                          <p id="error-message" style={{ color: "red" }}>
                            {validEmail}
                          </p>
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            Nature of Relationship{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            name="relationship"
                            id="marital_status"
                            className="form-control"
                            required
                            value={data.relationship}
                            onChange={handleChange}
                          >
                            <option
                              value=""
                              defaultValue="selected"
                              disabled="disabled"
                            >
                              -Choose Relationship{" "}
                              <span className="text-danger">*</span>
                            </option>
                            <option>Father</option>
                            <option>Mother</option>
                            <option>Guardian</option>
                            <option>Sponsor</option>
                          </select>
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            Gender <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="gender"
                            disabled
                            value={data.gender}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>Mothers Maiden Name </label>
                          <input
                            type="text"
                            className="form-control"
                            name="mothersMaidenName"
                            value={data.mothersMaidenName}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500">
                          <label>
                            State of origin{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control dropdown"
                            id="stateOfOrigin"
                            name="stateOfOrigin"
                            required
                            value={data.stateOfOrigin}
                            onChange={handleChange}
                          >
                            <option
                              value=""
                              defaultValue="selected"
                              disabled="disabled"
                            >
                              Select state of origin
                            </option>
                            {states.map((state) => (
                              <option
                                key={state.value}
                                value={`${state.value}#${state.text}`}
                              >
                                {state.text}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            L.G.A <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control dropdown"
                            id="lga"
                            name="lga"
                            required
                            value={data.lga}
                            onChange={handleChange}
                          >
                            <option
                              value=""
                              defaultValue="selected"
                              disabled="disabled"
                            >
                              --Select lga--
                            </option>
                            {lgas.map((lga) => (
                              <option
                                key={lga.value}
                                value={`${lga.value}#${lga.text}`}
                              >
                                {lga.text}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500">
                          <label>Resident Permit Number </label>
                          <input
                            type="text"
                            className="form-control"
                            name="residentPermitNumber"
                            value={data.residentPermitNumber}
                            onChange={handleChange}
                          />
                        </div> */}

                        {/* <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500">
                          <label>Place of Permit Issue </label>
                          <input
                            type="text"
                            className="form-control"
                            name="placeOfPermitIssue"
                            value={data.placeOfPermitIssue}
                            onChange={handleChange}
                          />
                        </div> */}

                        {/* <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500">
                          <label>Permit Issue Date </label>
                          <input
                            type="date"
                            className="form-control m-b-10"
                            name="permitIssueDate"
                            // max={getCurrentDate()}
                            value={data.permitIssueDate}
                            onChange={handleChange}
                          />
                        </div> */}

                        {/* <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500">
                          <label>Permit Expiry Date </label>
                          <input
                            type="date"
                            className="form-control m-b-10"
                            name="permitExpiryDate"
                            value={data.permitExpiryDate}
                            onChange={handleChange}
                            // max={getCurrentDate()}
                          />
                        </div> */}
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                  {/* <!-- </div> --> */}
                </div>

                {/* <!-- CONTACT DETAILS --> */}
                <div className="section-info m-b-50">
                  <div className="section-title font-weight-500 font-24 m-b-10 border-bottom p-1 text-suntrust">
                    <i className="fa fa-home m-r-5"></i>Contact Details
                  </div>

                  {/* <!-- <div className="row"> --> */}
                  <div className="main-section d-flex">
                    <div className="col-lg-3 col-md-12 col-sm-12 m-r-30 section-sub-text">
                      <div className="font-weight-300 font-14 text-gray">
                        This is a section where the address details of the
                        guardian is entered. Please, provide the correct
                        details.
                      </div>
                    </div>

                    <div className="section-forms p-10 col-lg-9">
                      {/* <!-- <div className="col-lg-12"> --> */}
                      <div className="row">
                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            Residential Address{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="residentialAddress"
                            required
                            value={data.residentialAddress}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            Nationality <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control dropdown"
                            id="nationality"
                            name="nationality"
                            required
                            value={data.nationality}
                            onChange={handleChange}
                          >
                            <option
                              value=""
                              defaultValue="selected"
                              disabled="disabled"
                            >
                              --Select nationality--
                            </option>
                            <option value={nationalityCode}>Nigeria</option>
                          </select>
                        </div>
                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500 m-b-30">
                          <label>
                            Residential LGA{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control dropdown"
                            id="residentialLGA"
                            name="residentialLGA"
                            required
                            value={data.residentialLGA}
                            onChange={handleChange}
                          >
                            <option
                              value=""
                              defaultValue="selected"
                              disabled="disabled"
                            >
                              --Select lga--
                            </option>
                            {lgas.map((lga) => (
                              <option
                                key={lga.value}
                                value={`${lga.value}#${lga.text}`}
                              >
                                {lga.text}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500">
                          <label>
                            State of residence{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            className="form-control dropdown"
                            id="stateOfResidence"
                            name="stateOfResidence"
                            required
                            value={data.stateOfResidence}
                            onChange={handleChange}
                          >
                            <option
                              value=""
                              defaultValue="selected"
                              disabled="disabled"
                            >
                              --Select state of residence--
                            </option>
                            {states.map((state) => (
                              <option
                                key={state.value}
                                value={`${state.value}#${state.text}`}
                              >
                                {state.text}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500">
                          <label>Introducer Code</label>
                          <input
                            type="text"
                            name="introducerCode"
                            className="form-control"
                            value={data.introducerCode}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="row m-t-10">
                        <div className="form-group col-lg-4 col-md-6 col-sm-12 m-b-30">
                          <label className="font-weight-500">
                            Do you have a SunTrust Bank Account?
                            <span className="text-danger">*</span>
                          </label>

                          <div className="eb_pref form-group">
                            <div className="custom-control custom-checkbox inline-cc col-lg-3 col-md-4 col-sm-12">
                              <input
                                type="radio"
                                className="custom-control-input"
                                name="haveSunTrustBankAccount"
                                value="yes"
                                id="yes1"
                                required
                                checked={isYesChecked}
                                onChange={handleYesChecked}
                                data-parsley-errors-container="#error-checkbox"
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="yes1"
                              >
                                Yes
                              </label>
                            </div>

                            <div className="custom-control custom-checkbox inline-cc col-lg-3 col-md-6 col-sm-12">
                              <input
                                type="radio"
                                className="custom-control-input"
                                name="haveSunTrustBankAccount"
                                checked={isNoChecked}
                                onChange={handleNoChecked}
                                value="no"
                                id="no1"
                                // checked={data.sunTrustAccount === 'no'}
                                // onChange={handleChange}
                                data-parsley-errors-container="#error-checkbox"
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="no1"
                              >
                                No
                              </label>
                            </div>
                            <p id="error-checkbox"></p>
                          </div>
                        </div>

                        <div className="form-group col-lg-4 col-md-6 col-sm-12 m-b-30">
                          {isYesChecked && (
                            <div className="form-group font-weight-500 m-b-30">
                              <label>If Yes, Enter your Account Number</label>
                              <input
                                type="text"
                                className="form-control"
                                maxLength={10}
                                name="sunTrustAccountNumber"
                                value={data.sunTrustAccountNumber}
                                onChange={validateAcctNum}
                                style={{
                                  paddingRight: "30px",
                                  position: "relative",
                                }}
                              />
                              {isLoading && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "50%",
                                    right: "25px",
                                    transform: "translateY(-50%)",
                                  }}
                                >
                                  <Loader />
                                </div>
                              )}
                            </div>
                          )}
                        </div>

                        {showAccountValid && !invalidAcctMsg && !isNoChecked ? (
                          <div className="form-group col-lg-4 col-md-6 col-sm-12 m-b-30">
                            <div className="form-group font-weight-500 m-b-30">
                              <label>Account Number</label>
                              <input
                                type="text"
                                className="form-control"
                                name="sunTrustAccountNumber"
                                disabled
                                required
                                value={data.accountName}
                                onChange={handleChange}
                              />
                            </div>
                          </div>
                        ) : (
                          <p id="error-message" style={{ color: "red" }}>
                            {invalidAcctMsg}
                          </p>
                        )}
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                  {/* <!-- </div> --> */}
                </div>

                {/* <!-- MEANS OF IDENTIFICATION DETAILS --> */}
                <div className="section-info m-b-50">
                  <div className="section-title font-weight-500 font-24 m-b-10 border-bottom p-1 text-suntrust">
                    <i className="fa fa-id-card m-r-5"></i> Means of
                    Identification
                  </div>

                  {/* <!-- <div className="row"> --> */}
                  <div className="main-section d-flex">
                    <div className="col-lg-3 col-md-12 col-sm-12 m-r-30 section-sub-text">
                      <div className="font-weight-300 font-14 text-gray">
                        This is a section where the Means of Identification
                        details of the guardian are entered. Please, provide the
                        correct details.
                      </div>
                    </div>

                    <div className="section-forms p-10 col-lg-9">
                      {/* <!-- <div className="col-lg-12"> --> */}
                      <div className="row">
                        <div className="form-group col-lg-6 col-md-6 col-sm-12 font-weight-500">
                          <label>ID Number</label>
                          <input
                            type="text"
                            className="form-control"
                            name="idNumber"
                            value={data.idNumber}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="form-group col-lg-6 col-md-6 col-sm-12 font-weight-500">
                          <label>Date of Issue</label>
                          <input
                            type="date"
                            className="form-control"
                            name="dateIssue"
                            value={data.dateIssue}
                            max={getCurrentDate()}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="form-group col-lg-6 col-md-6 col-sm-12 font-weight-500">
                          <label>Expiry Date</label>
                          <input
                            type="date"
                            className="form-control"
                            name="permitExpiryDate"
                            value={data.permitExpiryDate}
                            min={getCurrentDate()}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!-- ACCOUNT SIGNATORY --> */}

                <div className="section-info m-b-50">
                  <div className="section-title font-weight-500 font-24 m-b-10 border-bottom p-1 text-suntrust">
                    <i className="fa fa-users m-r-5"></i> Signatory Mandate
                  </div>

                  {/* <!-- <div className="row"> --> */}
                  <div className="main-section d-flex">
                    <div className="col-lg-3 col-md-12 col-sm-12 m-r-30 section-sub-text">
                      <div className="font-weight-300 font-14 text-gray">
                        This is a section where the Parents / Guardian will
                        decide who has signatory access to this account. Please,
                        tick where applicable.
                      </div>
                    </div>

                    <div className="section-forms p-10 col-lg-9">
                      {/* <!-- <div className="col-lg-12"> --> */}
                      <div className="row">
                        <div className="form-group col-lg-12 col-md-6 col-sm-12">
                          {/* <!-- <label className="font-weight-500">Account Signatory</label> --> */}

                          <div className="form-group">
                            {showSignatory && (
                              <div className="custom-control custom-checkbox inline-cc col-lg-3 col-md-12 col-sm-12 m-b-10">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  name="soleSignatory"
                                  value="soleSignatory"
                                  id="soleSignatory"
                                  required
                                  checked={data.soleSignatory}
                                  onChange={handleChange}
                                  data-parsley-errors-container="#error-checkbox"
                                />
                                <label
                                  className="custom-control-label"
                                  htmlFor="soleSignatory"
                                >
                                  Sole Signatory
                                </label>
                              </div>
                            )}

                            <div className="custom-control custom-checkbox inline-cc col-lg-3 col-md-12 col-sm-12 m-b-10">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                name="bothSignatory"
                                value="bothSignatory"
                                id="bothSignatory"
                                checked={data.bothSignatory}
                                onChange={handleChange}
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="bothSignatory"
                              >
                                Both Signatories
                              </label>
                            </div>
                            <div className="custom-control custom-checkbox inline-cc col-lg-3 col-md-12 col-sm-12 m-b-10">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                name="eitherSignatory"
                                value="eitherSignatory"
                                id="eitherSignatory"
                                checked={data.eitherSignatory}
                                onChange={handleChange}
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="eitherSignatory"
                              >
                                Either Signatory
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                  {/* <!-- </div> --> */}
                </div>
                {/* <!-- UPLOAD DOCUMENTS --> */}
                <div className="section-info m-b-50">
                  <div className="section-title font-weight-500 font-24 m-b-10 border-bottom p-1 text-suntrust">
                    <i className="fa fa-files-o m-r-5"></i> Upload Documents
                  </div>

                  {/* <!-- <div className="row"> --> */}
                  <div className="main-section d-flex">
                    <div className="col-lg-3 col-md-12 col-sm-12 m-r-30 section-sub-text">
                      <div className="font-weight-300 font-14 text-gray">
                        This is a section where the Documents for the child are
                        uploaded. Please,upload required documents.
                      </div>
                    </div>

                    <div className="section-forms p-10 col-lg-9 col-md-12 col-sm-12">
                      {/* <!-- <div className="col-lg-12"> --> */}
                      <div className="row">
                        <div className="form-group col-lg-12 col-md-12 col-sm-12 font-weight-500 m-b-30">
                          To confirm your identity, please upload copies of your
                          preffered documents. You must upload Utility Bill with
                          a valid address and 2 other preffered documents.
                        </div>

                        <div className="row col-lg-12 col-md-12 col-sm-12">
                          <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500">
                            <label>
                              SELECT A DOCUMENT TO UPLOAD{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-control dropdown"
                              id="document-type"
                              name="document-type"
                              onChange={(e) =>
                                setSelectedOption(e.target.value)
                              }
                            >
                              <option value="">--select ID type--</option>
                              {docs.map((doc) => (
                                <option
                                  key={doc.value}
                                  value={`${doc.value}#${doc.text}`}
                                >
                                  {doc.text}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="form-group col-lg-4 col-md-6 col-sm-12 font-weight-500">
                            <label>
                              UPLOAD A DOCUMENT{" "}
                              <span className="text-danger">*</span>
                            </label>

                            <input
                              type="file"
                              id="document-file"
                              name="document"
                              accept=".doc,.docx,.pdf..jpeg,.png,.PNG,.jpg"
                              onChange={(e) =>
                                setSelectedFile(e.target.files[0])
                              }
                            />
                            <p id="error-message" style={{ color: "red" }}>
                              {errorMessage}
                            </p>
                          </div>
                          <div></div>

                          <div className="form-group col-lg-4 col-md-12 col-sm-12 font-weight-500">
                            <label> &nbsp; </label>
                            <div className="form-group col-lg-6 col-md-12 col-sm-12">
                              <button
                                onClick={handleAddDocument}
                                className="btn btn-block btn-suntrust"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                        {Array.isArray(data.documents) &&
                        data.documents.length > 0 ? (
                          <div className="form-group col-lg-12 col-md-12 col-sm-12 font-weight-500">
                            <div className="table-responsive border">
                              <table className="table table-hover mb-0 c_list">
                                <thead
                                  className="font-weight-500"
                                  style={{ backgroundColor: "#eee" }}
                                >
                                  <tr>
                                    <th>S/N</th>
                                    <th>Title</th>
                                    <th>Attachment</th>
                                    <th className="d-flex align-items-center justify-content-center">
                                      Action
                                    </th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {data.documents.map((document, index) => {
                                    index = index === 0 ? 1 : index + 1;
                                    return (
                                      <tr key={index}>
                                        <td>{index}</td>
                                        <td>
                                          {document.documentType.split("#")[1]}
                                        </td>
                                        <td>{document.name}</td>
                                        <td className="d-flex align-items-center justify-content-center">
                                          <button
                                            type="button"
                                            className="btn btn-outline-primary btn-sm m-r-10"
                                            onClick={() =>
                                              handleViewDocument(document.file)
                                            }
                                          >
                                            <i className="fa fa-eye"></i>
                                          </button>

                                          <button
                                            type="button"
                                            className="btn btn-outline-danger btn-sm"
                                            onClick={() => deleteDoc(index)}
                                          >
                                            <i className="fa fa-trash-o"></i>
                                          </button>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      {/* <!-- </div> --> */}
                    </div>
                  </div>
                  {/* <!-- </div> --> */}
                </div>

                <div className="form-group col-lg-12 col-md-12 col-sm-12 m-b-20">
                  <div className="d-flex align-items-center justify-content-center m-t-20">
                    {!isLoading && guardianInformations.length < 1 ? (
                      <div className="col-lg-3 col-md-6 col-sm-12 m-b-10">
                        <button
                          className="btn btn-block btn-suntrust font-weight-500"
                          onClick={handlePrevClick}
                        >
                          Previous Page
                        </button>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="col-lg-3 col-md-6 col-sm-12 m-b-10">
                      <button
                        className="btn btn-block btn-suntrust font-weight-500"
                        type="submit"
                        onClick={handleChange}
                      >
                        {isLoading ? <Loader /> : "Add Parent / Guardian"}
                      </button>
                    </div>
                  </div>
                </div>
                {/* ) : (
                  ""
                )} */}
              </form>
            </div>

            {/* <!-- GUARDIAN TABLE --> */}
            {!isLoading && guardianInformations.length > 0 ? (
              <div className="section-info m-b-50">
                <div className="section-title font-weight-500 font-24 m-b-10 border-bottom p-1 text-suntrust">
                  <i className="fa fa-users m-r-5"></i> Parent / Guardian Table
                </div>

                {/* <!-- <div className="row"> --> */}
                <div className="main-section d-flex">
                  <div className="col-lg-3 col-md-12 col-sm-12 m-r-30 section-sub-text">
                    <div className="font-weight-300 font-14 text-gray">
                      This is a section where the Next of Kin for the child are
                      entered. Please, provide the correct details.
                    </div>
                  </div>

                  <div className="section-forms p-10 col-lg-9">
                    {/* <!-- <div className="col-lg-12"> --> */}
                    <div className="row">
                      <div className="form-group col-lg-12 col-md-12 col-sm-12">
                        <div className="table-responsive border">
                          <table className="table table-hover mb-0 c_list">
                            <thead
                              className="font-weight-500"
                              style={{ backgroundColor: "#eee" }}
                            >
                              <tr>
                                <th>S/N</th>
                                <th>Firstname</th>
                                <th>Lastname</th>
                                <th>Gender</th>
                                <th>Relationship</th>
                                <th className="d-flex align-items-center justify-content-center">
                                  Action
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {guardianInformations.map((guardian, index) => {
                                index = index === 0 ? 1 : index + 1;
                                return (
                                  <tr key={index}>
                                    <td>{index}</td>
                                    <td>{guardian.firstName}</td>
                                    <td>{guardian.surName}</td>
                                    <td>{guardian.gender}</td>
                                    <td>{guardian.relationship}</td>
                                    <td className="d-flex align-items-center justify-content-center">
                                      {/* <button
                                        className="btn btn-outline-danger btn-sm m-b-5 m-r-10"
                                        title="Edit"
                                      >
                                        <i className="fa fa-edit"></i>
                                      </button> */}
                                      <button
                                        type="button"
                                        className="btn btn-outline-danger btn-sm m-b-5"
                                        title="Delete"
                                        onClick={() => deleteCheck(index)}
                                        // onClick={() =>
                                        //   dispatch(
                                        //     deleteGuardianInformation(index)
                                        //   )
                                        // }
                                      >
                                        <i className="fa fa-trash-o"></i>
                                      </button>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    {/* <!-- </div> --> */}
                  </div>
                </div>
                {/* <!-- </div> --> */}
              </div>
            ) : (
              ""
            )}

            {!isLoading && guardianInformations.length > 0 ? (
              <div className="form-group col-lg-12 col-md-12 col-sm-12 m-b-20">
                <div className="d-flex align-items-center justify-content-center m-t-20">
                  <div className="user_acct_details col-lg-3 col-md-6 col-sm-12 m-b-10">
                    <button
                      className="btn btn-block btn-suntrust font-weight-500"
                      onClick={handlePrevClick}
                    >
                      Previous Page
                    </button>
                  </div>

                  <div className="user_acct_details col-lg-3 col-md-6 col-sm-12 m-b-10">
                    <button
                      className="btn btn-block btn-suntrust font-weight-500"
                      onClick={handleNextClick}
                    >
                      Next Page
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuardianParentPage;
